import {
  S3Client,
  PutObjectCommand,
  PutObjectCommandOutput,
  PutObjectCommandInput,
} from '@aws-sdk/client-s3';
import { formatForPuttingS3 } from './models';

type PutUploadFilePayload = {
  region: string;
  bucketName: string;
  uploadPath: string;
  accessKeyId: string;
  secretAccessKey: string;
  token: string;
  file: File;
};

export const putUploadFile = async ({
  region,
  bucketName,
  uploadPath,
  accessKeyId,
  secretAccessKey,
  token,
  file,
}: PutUploadFilePayload): Promise<PutObjectCommandOutput> => {
  const s3Client = new S3Client({
    region,
    credentials: {
      sessionToken: token,
      accessKeyId,
      secretAccessKey,
    },
  });

  // IE11ではfile.lastModifiedが未定義
  const lastModificationDateTime =
    'lastModified' in file
      ? new Date(file.lastModified)
      : ((file as any).lastModifiedDate as Date);
  // Set the parameters.
  const bucketParams: PutObjectCommandInput = {
    Bucket: bucketName,
    Key: uploadPath,
    Body: file,
    ContentType: file.type,
    Metadata: {
      original_name: encodeURIComponent(file.name),
      last_modification_date_time: encodeURIComponent(
        formatForPuttingS3(lastModificationDateTime)
      ),
    },
  };

  const data = await s3Client.send(new PutObjectCommand(bucketParams));
  return data;
};
